import type { ComponentProps, ReactNode } from "react";
import { classes } from "../classes.ts";
import styles from "./Action.module.css";

interface Looks {
  readonly row?: boolean;
  readonly inText?: boolean;
  readonly children: ReactNode;
}
type Goes = Looks & Omit<ComponentProps<"a">, "className"> & { readonly href: string };
type Does = Looks & Omit<ComponentProps<"button">, "className" | "type"> & { readonly href?: undefined };

export function Action({ row = false, inText = false, children, ...rest }: Goes | Does) {
  const className = classes(styles.action, row && styles.row, inText && styles.inText);
  if (rest.href !== undefined) return <a {...rest} className={className}>{children}</a>;
  return <button {...rest} type="button" className={className}>{children}</button>;
}
